import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShareOs: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="share-os"><path d="M7.75 6.25L12 1.75L16.25 6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 2.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 9.75H4.75V20.25H19.25V9.75H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShareOs;
